module.exports = __webpack_public_path__ + "img/second_door_coat.a38035ad.webp";